const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25654",
    transform: "translate(-320 -139)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 11",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(320.5 139.5)",
    style: {
      fill: "#fff",
      stroke: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13633",
    d: "M277.5 14.5h21a3.009 3.009 0 0 1 3 3v21a3.009 3.009 0 0 1-3 3h-21a3.009 3.009 0 0 1-3-3v-21a3.009 3.009 0 0 1 3-3zm5.4 15.8-3 4a.75.75 0 0 0 .6 1.2h15a.75.75 0 0 0 .6-1.2l-4.125-5.5a.744.744 0 0 0-1.2 0l-3.9 5.2-2.775-3.7a.744.744 0 0 0-1.2 0z",
    transform: "translate(60.5 139.5)",
    style: {
      fill: "#ae20ae",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageCard);
export default __webpack_public_path__ + "static/media/image-card.78c49dd12886cf05b6853054ad841782.svg";
export { ForwardRef as ReactComponent };